var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.231,
    height: 13.231,
    viewBox: "0 0 13.231 13.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gift",
    d: "M11.026,3.859h-.958a2.832,2.832,0,0,0,.958-2.205.551.551,0,1,0-1.1,0c0,1.446-1.307,1.946-2.3,2.118A5.145,5.145,0,0,0,8.27,1.654a1.654,1.654,0,1,0-3.308,0,5.145,5.145,0,0,0,.647,2.118c-.994-.171-2.3-.672-2.3-2.118a.551.551,0,0,0-1.1,0,2.832,2.832,0,0,0,.958,2.205H2.205A2.205,2.205,0,0,0,0,6.064v.551a1.1,1.1,0,0,0,1.1,1.1v2.757a2.76,2.76,0,0,0,2.757,2.757H9.372a2.76,2.76,0,0,0,2.757-2.757V7.718a1.1,1.1,0,0,0,1.1-1.1V6.064A2.205,2.205,0,0,0,11.026,3.859ZM6.616,1.1a.551.551,0,0,1,.551.551,4.251,4.251,0,0,1-.551,1.661,4.251,4.251,0,0,1-.551-1.661A.551.551,0,0,1,6.616,1.1ZM1.1,6.064a1.1,1.1,0,0,1,1.1-1.1H6.064V6.616H1.1Zm1.1,4.41V7.718H6.064v4.41H3.859a1.654,1.654,0,0,1-1.654-1.654Zm8.821,0a1.654,1.654,0,0,1-1.654,1.654H7.167V7.718h3.859ZM7.167,6.616V4.962h3.859a1.1,1.1,0,0,1,1.1,1.1v.551Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.80aa0907eb249cea194b050c6188871b.svg";
export { ForwardRef as ReactComponent };